export const PageHeader = ({ eyebrow, title, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
    <div>
      {eyebrow && <p className="text-xs font-semibold uppercase tracking-[0.2em] text-emerald-600">{eyebrow}</p>}
      <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mt-1">{title}</h1>
    </div>
    {children}
  </div>
);

export const Panel = ({ title, children, className = "", testId }) => (
  <section data-testid={testId} className={`rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-6 ${className}`}>
    {title && <h2 className="font-display text-base md:text-lg font-semibold mb-4">{title}</h2>}
    {children}
  </section>
);

export const Stat = ({ label, value, testId, accent = false }) => (
  <div data-testid={testId} className={`rounded-xl border p-5 ${accent ? "bg-slate-900 text-white border-slate-900 dark:bg-emerald-950/40 dark:border-emerald-900" : "bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-800"}`}>
    <p className={`text-[11px] uppercase tracking-wider font-semibold ${accent ? "text-emerald-400" : "text-slate-500"}`}>{label}</p>
    <p className="font-display text-3xl font-bold mt-2">{value}</p>
  </div>
);
